import { Box } from '@mui/material';
import { StepIconProps } from '@mui/material/StepIcon';

import { getIconComponent } from './utils/getIconComponent';
import { getStepColors } from './utils/getStepColors';

export function CustomStepIcon({ active, completed, icon }: StepIconProps) {
  const step = Number(icon);

  const { iconColor: color, backgroundColor } = getStepColors({ active, completed });

  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        borderRadius: '50%',
        backgroundColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {getIconComponent({ step, color })}
    </Box>
  );
}
